import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-add-to-cart-tile',
  styleUrl: 'lilu-add-to-cart-tile.scss',
  shadow: true,
})
export class LiluAddToCartTile {
  @Prop() class: string = '';
  @Prop() flag: string = '';
  @Prop() storeId: string = '';
  @Prop() arrow: boolean = false;

  getIcon() {
    if (this.class.indexOf('disabled') >= 0) {
      if (this.class.indexOf('info') >= 0) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path
              d="M8.75 14.25H10.25V8.49998H8.75V14.25ZM9.49998 6.78845C9.72883 6.78845 9.92065 6.71105 10.0755 6.55625C10.2303 6.40145 10.3077 6.20963 10.3077 5.98078C10.3077 5.75194 10.2303 5.56012 10.0755 5.4053C9.92065 5.2505 9.72883 5.1731 9.49998 5.1731C9.27112 5.1731 9.0793 5.2505 8.9245 5.4053C8.7697 5.56012 8.6923 5.75194 8.6923 5.98078C8.6923 6.20963 8.7697 6.40145 8.9245 6.55625C9.0793 6.71105 9.27112 6.78845 9.49998 6.78845ZM9.50165 19C8.18772 19 6.95268 18.7506 5.79655 18.252C4.6404 17.7533 3.63472 17.0765 2.7795 16.2217C1.92427 15.3669 1.24721 14.3616 0.748325 13.206C0.249442 12.0504 0 10.8156 0 9.50165C0 8.18772 0.249334 6.95268 0.748 5.79655C1.24667 4.6404 1.92342 3.63472 2.77825 2.7795C3.6331 1.92427 4.63834 1.24721 5.79398 0.748326C6.94959 0.249443 8.18437 0 9.4983 0C10.8122 0 12.0473 0.249334 13.2034 0.748001C14.3596 1.24667 15.3652 1.92342 16.2205 2.77825C17.0757 3.6331 17.7527 4.63834 18.2516 5.79398C18.7505 6.94959 19 8.18437 19 9.4983C19 10.8122 18.7506 12.0473 18.252 13.2034C17.7533 14.3596 17.0765 15.3652 16.2217 16.2205C15.3669 17.0757 14.3616 17.7527 13.206 18.2516C12.0504 18.7505 10.8156 19 9.50165 19ZM9.49998 17.5C11.7333 17.5 13.625 16.725 15.175 15.175C16.725 13.625 17.5 11.7333 17.5 9.49998C17.5 7.26664 16.725 5.37498 15.175 3.82498C13.625 2.27498 11.7333 1.49998 9.49998 1.49998C7.26664 1.49998 5.37498 2.27498 3.82498 3.82498C2.27498 5.37498 1.49998 7.26664 1.49998 9.49998C1.49998 11.7333 2.27498 13.625 3.82498 15.175C5.37498 16.725 7.26664 17.5 9.49998 17.5Z"
              fill="#808080"
            />
          </svg>
        );
      }
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#F3F3F3" />
        </svg>
      );
    } else if (this.class.indexOf('active') >= 0) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9" />
          <circle cx="12" cy="12" r="4" fill="#262626" />
        </svg>
      );
    }
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9" />
      </svg>
    );
  }

  render() {
    return (
      <Host>
        {this.flag ? (
          <div class={`flag`}>
            <lilu-p color="white" size="size-10" font="regular">
              {this.flag}
            </lilu-p>
          </div>
        ) : (
          ''
        )}

        <div class={`radio`}>{this.getIcon()}</div>
        <div>
          <div class={`head`}>
            <slot name={`head`}></slot>
            <div class={`tooltip`}>
              <slot name={`tooltip`}></slot>
            </div>
          </div>
          <div class={`body`}>
            <slot name={`body`}></slot>
          </div>
        </div>
        {this.class.indexOf('arrow') >= 0 ? (
          <div class={`arrow`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M4.89248 5.99999L0.29248 1.39999L1.34631 0.346161L7.00013 5.99999L1.34631 11.6538L0.29248 10.6L4.89248 5.99999Z" fill="#1C1B1F" />
            </svg>
          </div>
        ) : (
          ''
        )}
      </Host>
    );
  }
}
